import { CustomBranding, CustomBrandingJSON } from '../../../models/customBranding';

export type ProjectPreviewJSON = {
	id: number,
	name: string,
	custom_branding?: CustomBrandingJSON
}

export type ProjectPreviewParams = {
	id: number,
	name: string,
	customBranding?: CustomBranding
}

export class ProjectPreview {
	public id: number;
	public name: string;
	public customBranding?: CustomBranding;

	constructor( { id, name, customBranding }: ProjectPreviewParams ) {
		this.id = id;
		this.name = name;
		this.customBranding = customBranding;
	}

	static fromJson( json: ProjectPreviewJSON ) {
		return new ProjectPreview( {
			id: json.id,
			name: json.name,
			customBranding: json.custom_branding
		} );
	}
}
